import { Capacitor } from "@capacitor/core"

const LOCAL_IP = import.meta.env.VITE_LOCAL_IP ?? "127.0.0.1"
const SITE = "grubvision.com"

// Centralized service URL configuration.
const URLS = {
	"add-item": {
		remote: `https://add-item.${SITE}/`,
		local: `http://${LOCAL_IP}:8787/`,
	},
	"add-meal": {
		remote: `https://add-meal-plan.${SITE}/`,
		local: `http://${LOCAL_IP}:8789/`,
	},
	image: {
		// When running in a native (Capacitor) environment we may need a different URL.
		remote: `https://bucket.${SITE}/`,
		local: `http://${LOCAL_IP}:5173/api/image/`,
		// When running in a web browser, use the local API route.
		web: `/api/image/`,
	},
	// pdf: {
	// 	remote: `https://${SITE}/api/pdf/`,
	// 	local: `http://${LOCAL_IP}:5173/api/pdf/`,
	// },
	fetch: {
		remote: `https://${SITE}/api`,
		local: `http://${LOCAL_IP}:8788/api`,
		web: `/api`,
	},
}

// Toggle local URLs on native mode when debugging.
// You could also use: Capacitor.DEBUG
const vld = import.meta.env.VITE_LOCAL_DEV ?? false
const DEBUG = vld && vld === "1"
// console.log("DEBUG", DEBUG)

/**
 * Returns whether the current host is considered production.
 * This regex matches hosts like "grubvision.com" but not ones starting with "dev."
 * @param {string} host - The location host.
 * @returns {boolean}
 */
function isProductionHost(host) {
	return (
		/^(?!dev\.).*?grubvision\.com$/i.test(host) ||
		/^(?!dev\.).*?grub\.vision$/i.test(host)
	)
}

/**
 * Constructs the URL for the given service.
 *
 * @param {("add-item"|"add-meal"|"image"|"fetch")} service - The service key.
 * @param {string} [path=""] - An optional path segment to append.
 * @returns {string} - The full URL.
 * @throws {Error} - If an unknown service is requested.
 */
export default function getURL(service, path = "") {
	// For native (mobile) platforms, use the Capacitor configuration.
	if (Capacitor.isNativePlatform()) {
		// For 'image', 'add-item', 'add-meal' and 'fetch', pick local or remote based on DEBUG.
		if (service in URLS) {
			const baseUrl = DEBUG ? URLS[service].local : URLS[service].remote
			return baseUrl + path
		}
		throw new Error(`Unknown service: ${service}`)
	}

	// Web platform logic:
	// For images and fetch we have static routes.
	if (service === "image") {
		return URLS.image.web + path
	}
	if (service === "fetch") {
		return URLS.fetch.web
	}

	// For "add-item" and "add-meal" on the web, decide based on the host.
	const { host } = location
	const useRemote = isProductionHost(host)

	// if (service === "add-item" || service === "add-meal" || service === "pdf") {
	if (service === "add-item" || service === "add-meal") {
		const baseUrl = useRemote ? URLS[service].remote : URLS[service].local
		return baseUrl + path
	}

	throw new Error(`Unknown service: ${service}`)
}
